export const UPDATE_FK_RATING_SUCCESS = 'UPDATE_FK_RATING_SUCCESS';

export const updateFkRatingSuccess = results => ({
    type: UPDATE_FK_RATING_SUCCESS,
    payload: { results },
});
